import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider, App as AntApp } from 'antd';
import esES from 'antd/locale/es_ES';
import dayjs from 'dayjs';
import 'dayjs/locale/es';
import { AuthProvider, useAuth } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import AppLayout from './components/AppLayout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Productos from './pages/Productos';
import Movimientos from './pages/Movimientos';
import Categorias from './pages/Categorias';
import Proveedores from './pages/Proveedores';
import OrdenesCompra from './pages/OrdenesCompra';
import Facturas from './pages/Facturas';
import KPIsCategorias from './pages/KPIsCategorias';
import Usuarios from './pages/Usuarios';
import Auditoria from './pages/Auditoria';

dayjs.locale('es');

// El rol RH solo tiene acceso al módulo de Facturas, así que no aterriza en el Dashboard.
function Home() {
  const { user } = useAuth();
  if (user?.rol === 'rh') return <Navigate to="/facturas" replace />;
  return <Dashboard />;
}

const theme = {
  token: {
    colorPrimary: '#1677ff',
    colorSuccess: '#52c41a',
    colorWarning: '#faad14',
    colorError: '#ff4d4f',
    borderRadius: 8,
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif"
  },
  components: {
    Layout: {
      siderBg: '#001529',
      triggerBg: '#002140'
    }
  }
};

function App() {
  return (
    <ConfigProvider locale={esES} theme={theme}>
      <AntApp>
        <AuthProvider>
          <Router>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route
                path="/*"
                element={
                  <PrivateRoute>
                    <AppLayout>
                      <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/productos" element={<Productos />} />
                        <Route path="/movimientos" element={<Movimientos />} />
                        <Route path="/categorias" element={<Categorias />} />
                        <Route path="/proveedores" element={<Proveedores />} />
                        <Route path="/ordenes-compra" element={<OrdenesCompra />} />
                        <Route path="/facturas" element={<Facturas />} />
                        <Route path="/kpis-categorias" element={<KPIsCategorias />} />
                        <Route path="/usuarios" element={<Usuarios />} />
                        <Route path="/auditoria" element={<Auditoria />} />
                        <Route path="*" element={<Navigate to="/" replace />} />
                      </Routes>
                    </AppLayout>
                  </PrivateRoute>
                }
              />
            </Routes>
          </Router>
        </AuthProvider>
      </AntApp>
    </ConfigProvider>
  );
}

export default App;
